export const ACCESS_TOKEN_KEY = '@Numbox:accessTokens';
export const REFRESH_TOKEN_KEY = '@Numbox:authTokens';
